import React from "react";
import PropTypes from "prop-types";
import ClassPlanItem from "./ClassPlanItem";

function ClassPlanList({ data, onClick }) {
  return data.map(classPlan => (
    <ClassPlanItem key={classPlan.DATA} data={classPlan} onClick={onClick} />
  ));
}

ClassPlanList.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  onClick: () => {}
};

export default ClassPlanList;
